let blue = {
    50: '#D4EDFB',
    100: '#A7DBF6',
    200: '#7CC9F2',
    300: '#52B7ED',
    400: '#24A5E9',
    500: '#1E84BA',
    600: '#16638C',
    700: '#0F425D',
    800: '#0A3046',
    850: '#082534', // found this one on popup borders
    900: '#08202F',
    1000: '#061924',
    1100: '#03111A',
};

if (process.env.BRICATA_APPLIANCE_TYPE === 'mc2') {
    blue = {
        50: '#D4EDFB',
        100: '#A7DBF6',
        200: '#7CC9F2',
        300: '#52B7ED',
        400: '#24A5E9',
        500: '#1E84BA',
        600: '#16638C',
        700: '#585858',
        800: '#404040',
        850: '#082534',
        900: '#282828',
        1000: '#1F1F1F',
        1100: '#191919',
    };
}

const pumpkin = {
    50: '#FEE1CE',
    100: '#FEC29D',
    200: '#FEA46C',
    300: '#FD863B',
    400: '#FD6809',
    500: '#CC5307',
    600: '#993E05',
    700: '#662B04',
    800: '#4B2002',
    900: '#331601',
};

const purple = {
    // 10: '#E4DCF1',
    10: '#DCD4EA',
    25: '#D6CAE9',
    50: '#D7D0F2',
    100: '#AFA3E5',
    200: '#8876D9',
    300: '#6049CC',
    400: '#381BBF',
    500: '#2E1599',
    600: '#231073',
    700: '#160A4C',
    800: '#120739',
    900: '#0B0526',
    950: '#090a19',
};

const orange = {
    50: '#FFDACF',
    100: '#FEB59F',
    200: '#FD8F6F',
    300: '#FD6A3F',
    400: '#FD4610',
    500: '#CC370D',
    600: '#982B0A',
    700: '#661D06',
    800: '#4C1603',
    900: '#190701',
};

const teal = {
    50: '#D3F9FB',
    100: '#A8F3F6',
    200: '#7CEDF2',
    300: '#50E7ED',
    400: '#26E1E9',
    500: '#1DB3BA',
    600: '#16878B',
    700: '#0F5A5D',
    800: '#0A4346',
    900: '#082D2E',
};

const olive = {
    50: '#F2F8DD',
    100: '#E5EFBB',
    200: '#D9E799',
    300: '#CCE077',
    400: '#BFD855',
    500: '#99AD44',
    600: '#738134',
    700: '#4C5622',
    800: '#394219',
    900: '#262C10',
};

const skyBlue = {
    50: '#D3E1FB',
    75: '#BCD4F8',
    100: '#A7C6F6',
    150: '#93B8F4',
    200: '#7BA9F2',
    250: '#669CEF',
    300: '#528CED',
    350: '#3B7EEA',
    400: '#2470E9',
    500: '#155dd1',
};

const lavender = {
    50: '#EED3FF',
    75: '#E6BDFF',
    100: '#DEA7FF',
    150: '#D790FF',
    200: '#CE7AFF',
    250: '#C663FF',
    300: '#BD4EFF',
    350: '#B637FF',
    400: '#AE22FF',
};

const pointlessPuple = {
    50: '#E5DCF1',
    75: '#D6CAE9',
    100: '#C9BAE2',
    150: '#BBAADB',
    200: '#AD98D4',
    250: '#9F87CD',
    300: '#9075C5',
    350: '#8364BE',
    400: '#7653B7',
};

const yellow = {
    300: '#ffe733',
    400: '#FFE200',
    450: '#E5CC00',
    500: '#CBB500',
    550: '#B39E00',
    600: '#998800',
    650: '#807002', //
    700: '#675901',
    800: '#4D4301',
    900: '#332D00',
};

const red = {
    400: '#F5003C',
    450: '#DE0035',
    500: '#C40030',
    550: '#AB002A',
    600: '#920124',
    650: '#7B001E',
    700: '#620018',
    800: '#490012',
    900: '#30000C',
};

const pointlessPink = {
    50: '#E5D4E1',
    75: '#D6BFD2',
    100: '#CAA9C3',
    150: '#BD95B5',
    200: '#B07FA6',
    250: '#A36B96',
    300: '#955588',
    350: '#883F79',
    400: '#7B2A6A',
    500: '#1E84BA',
    600: '#16638C',
    700: '#72105D',
    800: '#0A3046',
    850: '#082534', // found this one on popup borders
    900: '#4C0B41',
    1000: '#3C0839',
    1100: '#32032C',
};

const neutrals1 = {
    0: '#F7F7F7',
    50: '#CDCFD1',
    100: '#9AA0A3',
    200: '#677076',
    300: '#344148',
    400: '#02111A'
};

const neutrals2 = {
    50: '#E0E6EA',
    100: '#C1CED7',
    200: '#A2B4C4',
    300: '#859CB0',
    400: '#66849C',
    500: '#80888C', // I pulled this from the filter drag icon for variables
    600: '#515151', // xgrid border
    700: '#4F585F', // 508 light theme filter builder
    800: '#1A73A3', // don't add to blue list too close to another color.
};

const normal = '#64D855';
const warning = '#FEEA00';
const critical = '#ED4141';

// 508 light theme
const normalLight = '#238616';
const warningLight = yellow[300];
const criticalLight = red[500];

export {
    blue,
    pumpkin,
    purple,
    orange,
    teal,
    olive,
    skyBlue,
    lavender,
    pointlessPuple,
    yellow,
    red,
    pointlessPink,
    normal,
    warning,
    critical,
    normalLight,
    warningLight,
    criticalLight,
    neutrals1,
    neutrals2,
};
